import { ParamIds, Places } from '../../../Constants'
import BorderoKeys from '../bordero.keys'

export class StatusProcessamentoKeys extends BorderoKeys {
    get place() {
        return Places.statusProcessamentoBordero
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.borderoStatusProcId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.borderoStatusProcId, value)
    }
}
